import { render, staticRenderFns } from "./ModalKardexInfo.vue?vue&type=template&id=363bb2d8&scoped=true"
import script from "./ModalKardexInfo.vue?vue&type=script&lang=js"
export * from "./ModalKardexInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalKardexInfo.vue?vue&type=style&index=0&id=363bb2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363bb2d8",
  null
  
)

export default component.exports